const SCROLL_TUNE_OFFSET = {
  desktop: 24,
  mobile: 12,
};

const getSectionTuneOffset = (targetElement) => {
  const isDesktop = window.innerWidth >= 750;
  const defaultOffset = isDesktop ? SCROLL_TUNE_OFFSET.desktop : SCROLL_TUNE_OFFSET.mobile;

  if (!targetElement) return defaultOffset;

  const customOffset = parseInt(
    targetElement.getAttribute(isDesktop ? 'data-scroll-offset-desktop' : 'data-scroll-offset-mobile'),
    10
  );

  return Number.isNaN(customOffset) ? defaultOffset : customOffset;
};

const getHeaderOffset = (targetElement) => {
  const header = document.querySelector('.site-header');
  const announcementBar = document.querySelector('.announcement-bar');
  const headerHeight = header ? header.getBoundingClientRect().height : 0;
  const announcementBarHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
  const tuneOffset = getSectionTuneOffset(targetElement);

  // Fine-tuning value for anchor scroll position (adjustable).
  return headerHeight + announcementBarHeight + tuneOffset;
};

const scrollToElementWithHeaderOffset = (targetElement, behavior = 'smooth') => {
  if (!targetElement) return;

  const y = targetElement.getBoundingClientRect().top + window.scrollY - getHeaderOffset(targetElement);
  window.scrollTo({ top: Math.max(y, 0), behavior });
};

const getAnchorTarget = (selectorValue) => {
  if (!selectorValue) return null;

  const selectorType = selectorValue.charAt(0) === '#' ? 'id' : selectorValue.charAt(0) === '.' ? 'class' : null;
  if (!selectorType) return null;

  const selector = `[${selectorType}="${selectorValue.substring(1).toLowerCase()}"]`;
  return document.querySelector(selector);
};

const scrollToTargetElementFromURL = () => {
  const anchorFromURL = document.URL.split('anker=')[1];
  if (!anchorFromURL) return;

  const targetElement = getAnchorTarget(anchorFromURL);
  if (!targetElement) {
    console.error(`Element for '${anchorFromURL}' not found.`);
    return;
  }

  if (targetElement.classList.contains('faq__header') && targetElement.nextElementSibling) {
    targetElement.nextElementSibling.setAttribute('data-active', 'true');
  }

  if (targetElement.classList.contains('faq__wrapper')) {
    targetElement.setAttribute('data-active', 'true');
  }

  setTimeout(() => {
    scrollToElementWithHeaderOffset(targetElement);
  }, 0);
};

const setupHashAnchorScroll = () => {
  const isHashLink = (href) => typeof href === 'string' && href.startsWith('#') && href.length > 1;

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!isHashLink(href)) return;

    const targetElement = document.querySelector(href);
    if (!targetElement) return;

    event.preventDefault();
    scrollToElementWithHeaderOffset(targetElement);
    history.replaceState(null, '', href);
  });

  if (window.location.hash && isHashLink(window.location.hash)) {
    const targetElement = document.querySelector(window.location.hash);
    if (!targetElement) return;

    setTimeout(() => {
      scrollToElementWithHeaderOffset(targetElement, 'auto');
    }, 0);
  }
};

scrollToTargetElementFromURL();
setupHashAnchorScroll();
